<template>
  <JoinLayout />
</template>
<script setup lang="ts">
import JoinLayout from '~/components/layout/join/JoinLayout.vue'
</script>
